<header id="homeHeader" class="homeHeaderFooter">
  <div class="bs-container">
    <a routerLink="/{{ dispLanguageCode }}" routerLinkActive="active">
      <img src="assets/img/kg-logo.png" />
    </a>
    <div class="navigation" [class.main-dashboard]="isMainDashboard()">
      <a routerLink="/{{ dispLanguageCode }}/tools" routerLinkActive="active">
        {{ 'Tools' | i18nextEager }}
      </a>
      <a routerLink="/{{ dispLanguageCode }}/lessons" routerLinkActive="active">
        {{ 'Lessons' | i18nextEager }}
      </a>
    </div>
    <div class="language-switcher">
      <div
        class="selector"
        *ngIf="sectionReady"
        dir="{{ dispLanguageDirection }}"
        (click)="onSwitchLanguage()"
      >
        <img src="assets/img/lang_white.png" />
        <span>{{ dispLanguageName }}</span>
        <i class="fas fa-chevron-up flip"></i>
      </div>
      <i class="fas fa-spinner fa-spin" *ngIf="!sectionReady"></i>
    </div>
  </div>
</header>

<section id="homeTools">
  <app-loader *ngIf="!sectionReady"></app-loader>
  <div class="bs-container" *ngIf="sectionReady">
    <app-dashboard-list
      *ngIf="isMainDashboard() || isToolsPage()"
      [title]="'Tools' | i18nextEager"
      [resources]="isToolsPage() ? tools : (tools | slice: 0 : 3)"
      [dispLanguageDirection]="dispLanguageDirection"
      [dispLanguageCode]="dispLanguageCode"
      [viewAllRoute]="isToolsPage() ? null : toolsRoute"
      (resourceClick)="navigateToResourcePage($event)"
    >
    </app-dashboard-list>

    <app-dashboard-list
      *ngIf="isMainDashboard() || isLessonsPage()"
      [title]="'Lessons' | i18nextEager"
      [resources]="isLessonsPage() ? lessons : (lessons | slice: 0 : 3)"
      [dispLanguageDirection]="dispLanguageDirection"
      [dispLanguageCode]="dispLanguageCode"
      [viewAllRoute]="isLessonsPage() ? null : lessonsRoute"
      (resourceClick)="navigateToResourcePage($event)"
    >
    </app-dashboard-list>
  </div>
</section>

<footer
  id="homeFooter"
  class="homeHeaderFooter"
  [ngClass]="{ 'section-loading': !sectionReady }"
>
  <div class="bs-container">
    {{ '©1994-{{ year }} Cru. All Rights Reserved.' | i18nextEager: { year:
    currentYear } }}
    <a href="https://godtoolsapp.com/terms-of-use/" target="_blank">{{
      'Terms of Use' | i18nextEager
    }}</a
    >.
    <a href="https://www.cru.org/us/en/about/privacy.html" target="_blank">{{
      'Privacy Policy' | i18nextEager
    }}</a
    >.
  </div>
</footer>

<div id="languageSwitchModal" *ngIf="langSwitchOn">
  <div class="modal-content">
    <div class="modal-close">
      <i class="fas fa-times" (click)="onSwitchLanguage()"></i>
    </div>
    <div class="language-search">
      <input
        #languageSearchInput
        type="search"
        dir="auto"
        [ngModel]="languageSearchText"
        (ngModelChange)="onLanguageSearchTextChange($event)"
        [placeholder]="'Search languages' | i18nextEager"
        [attr.aria-label]="'Search languages' | i18nextEager"
      />
    </div>
    <ul class="languages-grid">
      <li
        class="language"
        *ngFor="let lang of filteredLangs"
        (click)="onSelectLanguage(lang.code)"
      >
        {{ lang.name }}
      </li>
    </ul>
    <div
      class="no-language-results"
      role="status"
      aria-live="polite"
      [class.has-message]="showNoLanguagesMessage"
    >
      <ng-container *ngIf="showNoLanguagesMessage">
        {{ 'No languages found' | i18nextEager }}
      </ng-container>
    </div>
  </div>
</div>
